import { TUpdater } from '../reducers/updater';
import { INIT_UPDATER, RECEIVE_UPDATER_MSG } from './actionTypes';

export function initUpdater() {
  return async (dispatch: Function) => {
    dispatch(init());
  };
}

export function init() {
  return { type: INIT_UPDATER };
}

export function receiveUpdaterMsg(data: TUpdater) {
  return {
    type: RECEIVE_UPDATER_MSG,
    data,
  };
}
